/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */

import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import * as _redux from "./redux";
import store, { persistor } from "./redux/store";
import App from "./app/App";
import "./index.scss"; // Standard version
// import "./sass/style.react.rtl.css"; // RTL version
import "highlight.js/styles/googlecode.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "./_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
import "socicon/css/socicon.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";
// Datepicker
import "react-datepicker/dist/react-datepicker.css";
import "sweetalert2/dist/sweetalert2.min.css";
import {
  MetronicLayoutProvider,
  MetronicSplashScreenProvider,
  MetronicSubheaderProvider,
} from "./_metronic/layout";
import { MetronicI18nProvider } from "./_metronic/i18n";
import CacheBuster from "./app/CacheBuster";
import { StylesProvider } from "@material-ui/core";

import { BrowserRouter as Router } from "react-router-dom";

/**
 * Base URL of the website.
 *
 * @see https://vitejs.dev/guide/build.html#public-base-path
 */
const { BASE_URL } = import.meta.env;

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 * Version Trigger Staging Test
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/* const mock = */ _redux.mockAxios(axios);

/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
_redux.setupAxios(axios, store);

const Index = () => {
  return (
    <>
      <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
            // You can decide how and when you want to force reload
            refreshCacheAndReload();
          }

          return (
            <StylesProvider injectFirst>
              <MetronicI18nProvider>
                <MetronicLayoutProvider>
                  <MetronicSubheaderProvider>
                    <MetronicSplashScreenProvider>
                      <Router>
                        <App
                          store={store}
                          persistor={persistor}
                          basename={BASE_URL}
                        />
                      </Router>
                    </MetronicSplashScreenProvider>
                  </MetronicSubheaderProvider>
                </MetronicLayoutProvider>
              </MetronicI18nProvider>
            </StylesProvider>
          );
        }}
      </CacheBuster>
    </>
  );
};

ReactDOM.render(<Index />, document.getElementById("root"));
